import { useCallback, useEffect, useRef, useState } from 'react'

const useGetRealTime = (startCountingAtCreate: boolean = true) => {
    const [realTime, setRealTime] = useState<Date>(new Date())
    const timerRef = useRef<any>(undefined)

    const stopTime = useCallback(() => {
        if (timerRef && timerRef.current) clearInterval(timerRef.current)
    }, [])

    const startTime = useCallback(() => {
        timerRef.current = setInterval(() => setRealTime(new Date()), 1000)
    }, [setRealTime])

    useEffect(() => {
        return () => {
            stopTime()
        }
    }, [stopTime])

    useEffect(() => {
        if (startCountingAtCreate) {
            startTime()
        }
    }, [startTime, startCountingAtCreate])

    return [realTime, stopTime, startTime] as const
}

export default useGetRealTime
